import styled from 'styled-components/macro';

export const Ul = styled.ul`
  list-style-type: none;
  margin: 0;
  padding-left: 0;
`;

export const Li = styled.li``;
